import LanguageSwitcher from './LanguageSwitcher'
import withState from './withState'

export default withState(LanguageSwitcher)
